var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.article
    ? _c(
        "div",
        [
          _c("section", [
            _c(
              "div",
              { staticClass: "row", staticStyle: { padding: "0px 10px" } },
              [
                !_vm.hideTitle
                  ? _c("h2", { staticClass: "abstract-heading" }, [
                      _vm._v("Title and Abstract"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-12 form-group" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.article.title,
                        expression: "article.title",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", required: "required" },
                    domProps: { value: _vm.article.title },
                    on: {
                      keyup: function ($event) {
                        return _vm.checkTitle()
                      },
                      change: function ($event) {
                        return _vm.onChange()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.article, "title", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors && _vm.errors["title"]
                    ? _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        _vm._l(_vm.errors["title"], function (error) {
                          return _c("span", {
                            staticStyle: { color: "red" },
                            domProps: { innerHTML: _vm._s(error) },
                          })
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.titleWarning
                    ? _c("div", { staticStyle: { width: "100%" } }, [_vm._m(1)])
                    : _vm._e(),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("section", [
            _c(
              "label",
              {
                class: {
                  asterik:
                    !_vm.article ||
                    !_vm.article.section ||
                    !_vm.article.section.abstracts_disabled,
                },
              },
              [_vm._v("Abstract")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "author-metadata mt-0" }, [
              _c(
                "div",
                {
                  ref: "abstract",
                  staticClass: "row content-padding abstract",
                },
                [
                  _c(
                    "form",
                    { staticClass: "col-md-12 no-border" },
                    [
                      !_vm.article.section ||
                      (_vm.article.section &&
                        _vm.article.section.abstracts_disabled == 0)
                        ? [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.abstractType,
                                    expression: "abstractType",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "structuredAbstract",
                                  name: "abstractType",
                                  value: "structured",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.abstractType,
                                    "structured"
                                  ),
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      _vm.abstractType = "structured"
                                    },
                                    function ($event) {
                                      return _vm.onChange()
                                    },
                                  ],
                                  click: function ($event) {
                                    return _vm.changeAbstract("structured")
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("b", [_vm._v("Structured (Preferred)")]),
                              _vm._v(" "),
                              _c("span", { staticClass: "radio" }),
                              _vm._v(" "),
                              _vm._m(2),
                            ]),
                            _vm._v(" "),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.abstractType,
                                    expression: "abstractType",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "unstructuredAbstract",
                                  name: "abstractType",
                                  value: "unstructured",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.abstractType,
                                    "unstructured"
                                  ),
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      _vm.abstractType = "unstructured"
                                    },
                                    function ($event) {
                                      return _vm.onChange()
                                    },
                                  ],
                                  click: function ($event) {
                                    return _vm.changeAbstract("unstructured")
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("b", [_vm._v("Unstructured")]),
                              _vm._v(" "),
                              _c("span", { staticClass: "radio" }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Use for proposals, comments, tutorials, reviews, etc.\n                                "
                                ),
                                _c("b", [
                                  _vm._v(
                                    "Maximum " +
                                      _vm._s(_vm.unstructuredWordCount) +
                                      " words"
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "form-group mt-5" },
                                [
                                  _vm.extraText
                                    ? _c("div", [
                                        _c("label", [
                                          _vm._v(
                                            "\n                                        Extra text\n                                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.extraText,
                                              expression: "extraText",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: { height: "150px" },
                                          attrs: { id: "extraText" },
                                          domProps: { value: _vm.extraText },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onChange()
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.extraText =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.article.abstract_fields,
                                    function (text, section) {
                                      return _c("div", [
                                        _c(
                                          "label",
                                          {
                                            class: {
                                              asterik:
                                                section != "Trial Registration",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm._f("ucfirst")(section)
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.article.abstract_fields[
                                                  section
                                                ],
                                              expression:
                                                "article.abstract_fields[section]",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: { height: "150px" },
                                          style: {
                                            borderColor:
                                              _vm.errors &&
                                              _vm.errors[section] &&
                                              _vm.errors[section].length > 0
                                                ? "red"
                                                : "#b7b7b7",
                                          },
                                          attrs: { id: section },
                                          domProps: {
                                            value:
                                              _vm.article.abstract_fields[
                                                section
                                              ],
                                          },
                                          on: {
                                            keyup: function ($event) {
                                              return _vm.abstractUpdated(
                                                section
                                              )
                                            },
                                            change: function ($event) {
                                              return _vm.onChange()
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.article.abstract_fields,
                                                section,
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticStyle: { width: "100%" } },
                                          [
                                            _vm.errors &&
                                            _vm.errors[section] &&
                                            _vm.errors[section].length > 0
                                              ? _vm._l(
                                                  _vm.errors[section],
                                                  function (error) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                          width: "100%",
                                                          display:
                                                            "inline-block",
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(error))]
                                                    )
                                                  }
                                                )
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ])
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "text-align": "right",
                                    margin: "0px",
                                    width: "100%",
                                    float: "right",
                                    "font-size": "13px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Total word count: " +
                                      _vm._s(_vm.getWordCount()) +
                                      " / " +
                                      _vm._s(
                                        _vm.article.abstract_fields &&
                                          Object.keys(
                                            _vm.article.abstract_fields
                                          ).length == 1
                                          ? _vm.unstructuredWordCount
                                          : _vm.structuredWordCount
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        : [
                            _c("p", [
                              _vm._v(
                                "Abstracts are unavailable in this section."
                              ),
                            ]),
                          ],
                    ],
                    2
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "keywords" } }, [
              _vm._v("\n            Keywords\n        "),
            ]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.article.subject_class,
                  expression: "article.subject_class",
                },
              ],
              staticClass: "form-control",
              style: {
                borderColor:
                  _vm.errors &&
                  _vm.errors[_vm.section] &&
                  _vm.errors[_vm.section].length > 0
                    ? "red"
                    : "#b7b7b7",
              },
              attrs: { type: "text", id: "keywords", placeholder: "Keywords" },
              domProps: { value: _vm.article.subject_class },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.article, "subject_class", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.errors && _vm.errors["keywords"]
              ? _c("p", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.errors["keywords"][0])),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.showAiUsage
            ? _c("ai-usage-declaration", {
                ref: "aiUsage",
                attrs: {
                  "article-id": _vm.article.article_id,
                  "edit-decision-id": _vm.editDecisionId,
                  "change-event": _vm.changeEvent,
                },
                on: {
                  loaded: _vm.onAiUsageLoaded,
                  "completion-change": _vm.onAiUsageCompletionChange,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "save-button",
              class: {
                deactive:
                  _vm.saving ||
                  _vm.invalidTransferSelections ||
                  (_vm.saveVersion &&
                    (!_vm.isFileUploaded || !_vm.hasEditorResponse)) ||
                  (_vm.showAiUsage && !_vm.aiUsageComplete),
              },
              staticStyle: { display: "block", margin: "1rem 0.25rem 0px 0px" },
              style: {
                float: _vm.hideTitle
                  ? _vm.cancelEvent
                    ? "left"
                    : "none"
                  : "right",
              },
              attrs: { type: "button", disabled: _vm.saving },
              on: {
                click: function ($event) {
                  return _vm.saveMetadata()
                },
              },
            },
            [
              _vm.saving
                ? _c("span", {
                    staticClass: "spinner-grow spinner-grow-sm",
                    attrs: { role: "status", "aria-hidden": "true" },
                  })
                : _vm._e(),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.saving
                      ? "Saving..."
                      : _vm.saveText
                      ? _vm.saveText
                      : "Save non-author metadata"
                  ) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.cancelEvent != false
            ? _c(
                "button",
                {
                  staticClass: "secondary-button",
                  staticStyle: {
                    display: "inline-block",
                    margin: "1rem 0px 0px 0.25px",
                  },
                  attrs: { type: "button", id: "cancelSavingNonAuthor" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v("\n        Cancel\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.errors &&
          Object.keys(_vm.errors).length > 0 &&
          Object.keys(_vm.errors).filter((key) => {
            return _vm.errors[key].length > 0
          }).length > 0
            ? _c("div", [
                _c("p", { staticStyle: { margin: "0px" } }, [
                  _vm._v("\n            Some errors have occured:\n        "),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(
                    Object.keys(_vm.errors).filter((key) => {
                      return _vm.errors[key].length > 0
                    }),
                    function (errorSection) {
                      return _c(
                        "li",
                        _vm._l(
                          _vm.errors[errorSection].filter((error) => {
                            return error != ""
                          }),
                          function (error) {
                            return _c("p", {
                              staticStyle: { color: "red" },
                              domProps: { innerHTML: _vm._s(error) },
                            })
                          }
                        ),
                        0
                      )
                    }
                  ),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.titleWarning ? _c("div", [_vm._m(4)]) : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "fname" } }, [
      _vm._v("Title"),
      _c("span", { staticClass: "required" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticStyle: { margin: "0px", color: "#e09202" } }, [
      _vm._v("\n                        WARNING: Please read our "),
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://support.jmir.org/hc/en-us/articles/115002943791",
          },
        },
        [_vm._v("title guidelines")]
      ),
      _vm._v(" and make sure to add a colon followed by the "),
      _c(
        "a",
        {
          attrs: {
            href: "https://support.jmir.org/hc/en-us/articles/360032676471?flash_digest=adb2e0dc7d3a5ccefe02dd4f06ce545db43fbbaa",
          },
        },
        [_vm._v("method/design")]
      ),
      _vm._v(" to the title, if appropriate.\n                    "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Use for original paper, systematic review or consensus paper.\n                                "
      ),
      _c("b", [_vm._v("Maximum 450 words")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "\n            Choose terms that best describe the submission's content\n            following the categories used by this journal, and examples\n            provided by the editor. Please add up to 10 keywords.\n\n            "
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n\n            Separate terms with a semi-colon (term1; term2; term3).\n        "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticStyle: { margin: "0px", color: "#e09202" } }, [
      _vm._v("\n            WARNING: Please read our "),
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://support.jmir.org/hc/en-us/articles/115002943791",
          },
        },
        [_vm._v("title guidelines")]
      ),
      _vm._v(" and make sure to add a colon followed by the "),
      _c(
        "a",
        {
          attrs: {
            href: "https://support.jmir.org/hc/en-us/articles/360032676471?flash_digest=adb2e0dc7d3a5ccefe02dd4f06ce545db43fbbaa",
          },
        },
        [_vm._v("method/design")]
      ),
      _vm._v(" to the title, if appropriate.\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }